/**
 * Mock 后端 API 接口
 * 这些函数模拟真实后端API的调用，用于前端开发和测试
 */

import { LiveRoom } from '../types';

/**
 * 爬取B站直播间基础信息
 * @param roomUrl 直播间URL（例如：https://live.bilibili.com/123456）
 * @returns 直播间基础信息
 */
export const scrapeRoomInfo = async (roomUrl: string): Promise<LiveRoom> => {
  // 从 URL 提取房间号
  const roomIdMatch = roomUrl.match(/live\.bilibili\.com\/(\d+)/);
  if (!roomIdMatch) {
    throw new Error('无效的直播间 URL');
  }
  
  const roomId = parseInt(roomIdMatch[1]);

  try {
    // 调用B站公开API获取真实房间信息
    const response = await fetch(`https://api.live.bilibili.com/room/v1/Room/get_info?room_id=${roomId}`);
    const data = await response.json();

    if (data.code !== 0) {
      throw new Error('获取房间信息失败');
    }

    // 获取主播信息
    const userResponse = await fetch(`https://api.live.bilibili.com/live_user/v1/Master/info?uid=${data.data.uid}`);
    const userData = await userResponse.json();
    const streamerName = userData.code === 0 ? userData.data.info.uname : `主播${roomId}`;

    return {
      room_id: roomId,
      streamer_name: streamerName,
      room_title: data.data.title,
      cover_url: data.data.user_cover || data.data.keyframe || 'https://i0.hdslb.com/bfs/live/new_room_cover/live_room_cover_default.jpg',
      description: data.data.description || '',
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    };
  } catch (error) {
    console.error('获取B站房间信息失败，使用默认值:', error);
    // Fallback到默认值
    return {
      room_id: roomId,
      streamer_name: `主播${roomId}`,
      room_title: `直播间${roomId}`,
      cover_url: 'https://i0.hdslb.com/bfs/live/new_room_cover/live_room_cover_default.jpg',
      description: '',
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    };
  }
};

